import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Translate } from "react-redux-i18n";
import _ from "lodash";
import styled from "styled-components";
import Layout from "../Layouts/LayoutMain";
import Category from "../Components/Common/Category";
import { ContentContainer } from "../Components/Common/ContentContainer";
import AlreadyApprovedModal from "../Components/Modals/AlreadyApprovedModal";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import Constants from "../AppConstants/Constants";
import { updateAlreadyApprovedModalState } from "../Store/Modals/Actions";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";

// region Style
const ImgArea = styled.area`
    cursor: pointer;
`;

const FlexRow = styled.div`
    // Extra small devices (portrait phones, less than 576px)
    @media (max-width: 575.98px) {
        margin-bottom: 30px;
    }

    // Extra large devices (large desktops, 1200px and up)
    @media (min-width: 992px) {
        margin-bottom: 30px;
        display: flex;
    }
`;

const CategoryFlexRow = styled(FlexRow)`
    // Medium devices (tablets, 768px and up)
    @media (min-width: 768px) {
        flex-wrap: wrap;
    }
`;

const FlexColumn = styled.div`
    ${FlexRow} & {
        // Extra large devices (large desktops, 1200px and up)
        @media (min-width: 992px) {
            flex: 1;
        }
    }
`;

const Feature = styled.div`
    .col-md-6:last-of-type & {
        margin-bottom: 0;
    }
  
    // Large devices (desktops, 992px and up)
    @media (min-width: 992px) {
        margin-bottom: 0;
        height: 100%;
    }
`;

// const LeaseBanner = styled.div`
//     background: url(${props => props.backgroundUrl}) no-repeat;
//     background-size: contain;
//     height: 98px;
//     margin-left: 15px;
// `;
//
// const LeaseBannerButtonContainer = styled.div`
//     margin-top: 50px;
//
//     // Medium devices (tablets, less than 992px)
//     @media (max-width: 991.98px) {
//         margin-top: 30px;
//     }
// `;
//
// const BannerButton = styled(Link)`
//     width: 140px;
//     padding: 0.5em;
//     line-height: 1em;
//
//     &.btn--warning {
//         background-color: #F0ED3E;
//         border-color: #F0ED3E;
//         color: #095C6C;
//
//         span {
//             color: #095C6C;
//         }
//     }
//
//     &.btn-outline-warning {
//         background-color: transparent;
//         border-color: #F0ED3E;
//         border-width: 2px;
//         color: #F0ED3E;
//
//         span {
//             color: #F0ED3E;
//         }
//
//         &:hover, &:focus, &:active {
//             color: #095C6C;
//
//             span {
//                 color: #095C6C;
//             }
//         }
//     }
//
//     &:hover, &:focus, &:active {
//         background-color: #f0e617 !important;
//         border-color: #f0e617 !important;
//     }
//
//     &:last-child {
//         width: 160px;
//         margin-left: 1.4em;
//     }
//
//     // Medium devices (tablets, less than 992px)
//     @media (max-width: 991.98px) {
//         width: 90px;
//         font-size: 7pt;
//
//         &.btn-outline-warning {
//             border-width: 1px;
//         }
//
//         &:last-child {
//             width: 100px;
//             margin-left: 0.7em;
//         }
//     }
// `;
// endregion

class HomePage extends Component {
    constructor(props) {
        super(props);

        this.onLearnMoreClick = this.onLearnMoreClick.bind(this);
        this.onGetApprovedClick = this.onGetApprovedClick.bind(this);
        this.onAlreadyApprovedClick = this.onAlreadyApprovedClick.bind(this);
        this.onCarouselClick = this.onCarouselClick.bind(this);
    }

    renderLinks() {
        const { categories } = this.props;
        // new array to push categories with showOnHomePage property
        const homePageCategories = [];
        if (categories && categories.length > 0) {
            this.getHomePageCategories(categories, homePageCategories);
            if (categories) {
                return _.map(homePageCategories, category =>
                    <Category
                        key={category.id}
                        filter="Category"
                        image={category.pictureModel.fullSizeImageUrl}
                        title={category.name}
                        description={category.description}
                        pageUrl={category.pageUrl}
                        id={category.id}
                    />
                );
            }
        }
    }

    getHomePageCategories(categories, homePageCategories) {
        _.each(categories, category => {
            if (category.name.toLowerCase().includes("devices")) {
                category.name = "Devices";
            }
            // the property for showOnHomePage is set to true in Reducers/Catalog/Categories.js file, along with pageUrl and description. The api from admin wasn't returning showOnHomePage.
            if (category.showOnHomePage) {
                homePageCategories.push(category);
            }

            if (category.subCategories.length > 0) {
                this.getHomePageCategories(category.subCategories, homePageCategories);
            }
        })
    }

    onLearnMoreClick() {
        const { history } = this.props;

        history.push(Constants.ENDPOINTS.PAYMENT_OPTIONS);
    }

    onGetApprovedClick() {
        const { history } = this.props;

        history.push(Constants.ENDPOINTS.LEASE_APPLICATION);
    }

    onAlreadyApprovedClick() {
        const { updateAlreadyApprovedModalState } = this.props;

        updateAlreadyApprovedModalState(true);
    }

    renderCarouselItems() {
        const { nivoSlider } = this.props;

        if (nivoSlider && nivoSlider.length > 0) {
            const filteredItems = _.filter(nivoSlider, item => item.pictureUrl && item.pictureUrl.length > 0);

            return _.map(filteredItems, item =>
                <div key={item.pictureUrl} className={`cellular-banner-logo ${item.link && item.link.length > 0 ? "clickable" : ""}`}>
                    <img alt="cellular Banner" src={item.pictureUrl} />
                </div>
            );
        }
    }

    onCarouselClick(index) {
        const { nivoSlider, history } = this.props;

        if (nivoSlider && nivoSlider.length > 0) {
            const filteredItems = _.filter(nivoSlider, item => item.pictureUrl && item.pictureUrl.length > 0);
            const item = filteredItems[index];

            if (item.link.length > 0) {
                if (item.link.includes("http")){
                    window.open(item.link, "_blank");
                } else {
                    history.push(item.link);
                }
            }
        }
    }

    render() {
        const { i18n, isAuthenticated } = this.props;

        return (
            <Layout isAuthenticated={isAuthenticated}>
                <div className="homepage-container">
                    <ContentContainer containerClassName="kits-solutions-container" style={{ paddingTop: "2em" }}>
                        <div className="row">
                            <div className="col-12 home-banner-logo" style={{ marginBottom: 30 }}>
                                <Carousel
                                    interval={6000}
                                    infiniteLoop
                                    autoPlay
                                    showThumbs={false}
                                    showArrows={false}
                                    showStatus={false}
                                    dynamicHeight
                                    swipeable
                                    onClickItem={this.onCarouselClick}
                                >
                                    {this.renderCarouselItems()}
                                </Carousel>
                            </div>
                        </div>
                        <FlexRow className="row">
                            <FlexColumn className="col-md-6 col-lg-7 col-xl-8">
                                <Feature className="feature feature-1 boxed boxed--border csp-feature" style={{
                                    background    : `url(${require("../../Assets/Images/img-kit-background.jpg")}) no-repeat`,
                                    backgroundSize: "cover"
                                }}>
                                    <h2>FedEx Ground CSPs</h2>
                                    <p><Translate value="home.cspBlock.description" /></p>
                                    <div className="row btn-row">
                                        <div className="col-12 col-sm-4 col-md-6 col-lg-4 col-xl-3">
                                            <Link className="btn" to={Constants.ENDPOINTS.KITS}>
                                                <span className="btn__text text-uppercase"><Translate value="home.cspBlock.shopKitsBtn" /></span>
                                            </Link>
                                        </div>
                                        <div className="col-12 col-sm-4 col-md-6 col-lg-4 col-xl-3">
                                            <Link className="btn" to={Constants.ENDPOINTS.BUILD_A_KIT}>
                                                <span className="btn__text text-uppercase"><Translate value="home.cspBlock.buildAKitBtn" /></span>
                                            </Link>
                                        </div>
                                    </div>
                                </Feature>
                            </FlexColumn>
                            <FlexColumn className="col-md-6 col-lg-5 col-xl-4">
                                <Feature className="feature feature-1 boxed boxed--border solutions-feature" style={{
                                    background    : `url(${require("../../Assets/Images/FXGTruckGray.png")}) no-repeat`,
                                    backgroundSize: "cover"
                                }}>
                                    <h3><Translate value="home.vTrackBlock.header" /></h3>
                                    <p><Translate value="home.vTrackBlock.description" /></p>
                                    <div className="row btn-row">
                                        <div className="col-12 col-sm-4 col-md-6">
                                            <a className="btn" href="https://www.vtrack.com/ISP" target="_blank">
                                                <span className="btn__text text-uppercase"><Translate value="misc.learnMore" /></span>
                                            </a>
                                        </div>
                                        <div className="col-12 col-sm-4 col-md-6">
                                            <Link className="btn" to={Constants.ENDPOINTS.VTRACK}>
                                                <span className="btn__text text-uppercase"><Translate value="misc.buyNow" /></span>
                                            </Link>
                                        </div>
                                    </div>
                                </Feature>
                            </FlexColumn>
                        </FlexRow>
                        <div className="row">
                            <div className="col-12 payment-banner-logo">
                                <img alt="Payment Banner" useMap="#buttonMap" src={require(`../../Assets/Images/AlreadyApprovedBanner.${i18n.locale}.jpg`)}/>

                                <map name="buttonMap">
                                    <ImgArea shape="rect" coords="300,60,421,87" alt="Learn More" onClick={this.onLearnMoreClick} />
                                    <ImgArea shape="rect" coords="772,48,914,80" alt="Get Approved" onClick={this.onGetApprovedClick} />
                                    <ImgArea shape="rect" coords="931,48,1092,80" alt="Already Approved" onClick={this.onAlreadyApprovedClick} />
                                </map>
                            </div>
                        </div>
                    </ContentContainer>
                    <ContentContainer>
                        <CategoryFlexRow className="row home-links-row">
                            {this.renderLinks()}
                        </CategoryFlexRow>
                    </ContentContainer>
                </div>
                <AlreadyApprovedModal/>
            </Layout>
        );
    }
}

HomePage.propTypes = {
    updateAlreadyApprovedModalState: PropTypes.func,
    i18n: PropTypes.object,
    userInfo: PropTypes.object,
    categories: PropTypes.array,
    nivoSlider: PropTypes.array,
    isAuthenticated: PropTypes.bool,
    history: PropTypes.object
};

function mapStateToProps(state) {
    return {
        i18n: state.i18n,
        userInfo: state.userInfo,
        categories: state.categories,
        nivoSlider: state.nivoSlider
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        updateAlreadyApprovedModalState: updateAlreadyApprovedModalState
    }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HomePage));